import gql from "graphql-tag";

export const RESEND_INVITE_MUTATION = gql`
  mutation ResendInvite($email: String!) {
    resendInvite(email: $email) {
      ok
    }
  }
`;
